const studyAbroad = {
  path: 'studyAbroad',
  component: resolve => require(['../../../components/pages/studyAbroad'], resolve)
}

export default studyAbroad
